module.exports = __webpack_public_path__ + "static/media/kr.7ce5a140.svg";